export default {
  meta: {
    title: '完整报告',
    url: '/abside/report',
    urlName: 'ab侧-完整报告',
    logincallback: '/abside',
  }
};
